// AUTO-GENERATED FILE: This file is automatically generated when you create a custom component
// using `yarn create-custom-component <ComponentName>`. This is a starting template that you
// can and should edit to set your component's schema URL and type.
// Single source of truth for schemaUrl and componentType
// Used by both admin and guest configs
export const STAY_BOOKING_ASSISTANT_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/stayBookingAssistant_V2_0_1.json' as const;
export const STAY_BOOKING_ASSISTANT_COMPONENT_TYPE = 'StayBookingAssistant' as const;

// Mode options
export enum StayBookingAssistantMode {
  Simple = 'simple',
  Advanced = 'advanced',
}

// Layout options for advanced mode
export enum AdvancedModeLayout {
  SimpleHotelList = 'simpleHotelList',
  HotelTilesCarousel = 'hotelTilesCarousel',
}

export const HOTELS_PER_PAGE_MOBILE = 3;
export const HOTELS_PER_PAGE_DESKTOP = 3;
